import * as ng from 'angular';
import * as _ from 'underscore';

import { FormField } from '../../shared/models/self-reg-settings';
import { Participant } from '../../shared/sync.service';
import { EventDetail } from '../../events';
import countries from '../../shared/countries';
import { Country, State } from '../../shared';
import { MinAgeService } from '../../age-gate';

export class FormFieldsController implements ng.IComponentController {
   static $inject = ['minAgeService'];

   constructor(
      private minAgeService:MinAgeService
   ) { }

   fields:FormField[];
   model:Participant;
   event:EventDetail;
   language:string;

   ngFormCtrl:ng.IFormController;

   /**
    * Currently selected country, defaults to event country.
    * Country is used to validate/format phone and postal code.
    */
   country:Country;

   eventState:State;
   eventCountry:Country;

   readonly countries = countries;

   $onInit() {
      this.eventCountry = _.findWhere(countries, {code: this.event.countryCode});
      this.eventState = _.findWhere(this.eventCountry.states, {code: this.event.stateCode});
      this.country = this.eventCountry;
   }

   $onChanges(changes:ng.IOnChangesObject) {
      if (changes.fields) {
         this.fields.sort(function(a, b) {
            if (a.row < b.row) return -1;
            if (a.row > b.row) return 1;
            if (a.col < b.col) return -1;
            if (a.col > b.col) return 1;
         });
      }
   }

   get minAge() {
      return this.minAgeService.getMinAge(this.eventState, this.eventCountry);
   }

   get minAgeError() {
      return this.minAgeService.getMinAgeError();
   }
}

ng.module('selfReg').component('formFields', {
   templateUrl: require('./form-fields.html'),
   controller: FormFieldsController,
   require: {
      ngFormCtrl: '^form'
   },
   bindings: {
      fields: '<',
      model: '<',
      event: '<',
      language: '<'
   }
});
